import axios from "axios";

export const GET_INVOICE_ORDERS_URL = "/invoiceOrders/getInvoiceOrders";
export const SEND_INVOICE_ORDERS_TO_RIVHIT_URL = "/invoiceOrders/sendInvoiceOrdersToRivhit";
export const SET_INVOICE_ORDER_SENT_MANUALLY_URL = "/invoiceOrders/setInvoiceOrderSentManually";

export function findInvoiceOrders(possibleCustomers) {
  return (queryParams, cancellationHandlers) => axios.get(
    GET_INVOICE_ORDERS_URL,
    {params: {...queryParams, possibleCustomers}, ...cancellationHandlers}
  );
}

export function sendInvoiceOrders(invoiceOrdersArray) {
  return axios.post(SEND_INVOICE_ORDERS_TO_RIVHIT_URL, {invoiceOrdersArray});
}

export function setInvoiceOrderSentManually(invoiceOrderID) {
  return axios.post(SET_INVOICE_ORDER_SENT_MANUALLY_URL, {invoiceOrderID});
}
